import { motion } from "framer-motion";
import { Dumbbell, ShieldCheck, BatteryCharging } from "lucide-react";
import Reveal from "./Reveal";

const ITEMS = [
  {
    icon: Dumbbell,
    title: "Proper Form & Mechanics",
    body: "Master the essential movements the right way — the foundation everything else is built on.",
  },
  {
    icon: ShieldCheck,
    title: "Train Safely & Effectively",
    body: "Learn how to push hard and progress without injury, so you can keep showing up.",
  },
  {
    icon: BatteryCharging,
    title: "Energy & Recovery Habits",
    body: "Baseline nutrition and recovery habits that sustain your energy long after the camp ends.",
  },
];

export default function Learn() {
  return (
    <section
      data-testid="learn-section"
      className="relative py-28 sm:py-40 px-5 sm:px-8"
    >
      <div className="max-w-[1400px] mx-auto">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase font-bold text-[#d4af37] mb-5">
            The Curriculum
          </p>
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mb-20 max-w-3xl">
            What you will <span className="gold-text">walk away with</span>
          </h2>
        </Reveal>

        <div className="relative">
          {/* Vertical timeline line */}
          <div className="absolute left-[27px] top-4 bottom-4 w-px bg-gradient-to-b from-[#d4af37]/60 via-[#d4af37]/20 to-transparent hidden sm:block" />

          <div className="space-y-14">
            {ITEMS.map((item, i) => {
              const Icon = item.icon;
              return (
                <Reveal key={item.title} delay={i * 0.12}>
                  <div className="flex gap-6 sm:gap-10 items-start">
                    <div className="relative z-10 shrink-0 w-14 h-14 rounded-full bg-[#111111] border border-[#d4af37]/40 flex items-center justify-center">
                      <Icon className="w-6 h-6 text-[#d4af37]" strokeWidth={1.5} />
                    </div>
                    <div className="pt-1">
                      <h3 className="font-display font-bold text-2xl sm:text-3xl mb-3">
                        {item.title}
                      </h3>
                      <p className="text-lg font-light text-neutral-300 leading-relaxed max-w-2xl">
                        {item.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
